var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-fixed tw-z-[1000] tw-right-0 tw-top-0 tw-block tw-w-2/3 md:tw-w-1/3 tw-pr-1 tw-pt-1"},_vm._l((_vm.getNotifyList),function(item,index){return _c('span',{key:_vm.uuid(item)},[_c('vNotify',{attrs:{"item":item,"index":index}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }